@if (gridOptions) {
  <dv-grid [actions]="actions()">
    <ag-grid-angular
      vtGridWithSidesheet
      dvPinSelectedRow
      class="ag-theme-devinco"
      [gridOptions]="gridOptions"
      (selectionChanged)="onSelectionChanged($event)">
    </ag-grid-angular>
  </dv-grid>
}
